/**
 * @fileoverview `useFormSecurityTranslate(t)` — the form-security corpus's translator, bound from
 * the ONE shared factory (`@puffin-core/i18n-bootstrap/namespace-translate`).
 * @package @puffin-core/form-security
 *
 * Resolution order: the consumer's `t` → the `formSecurity` namespace (registered at boot by
 * `@puffin-core/i18n-namespaces`, in BOTH the app and the marketing registry) → the English bundle,
 * so a tree with no i18n provider renders readable English rather than a raw dotted key.
 *
 * ⚠️ Bound from the factory, NOT hand-rolled the way `@puffin-core/captcha-ui`'s
 * `useCaptchaTranslate` still is. The string BUNDLE mirrors captcha-ui's exactly; the hook follows
 * the newer standard (`break-compliance-ui`, `privacy-ui`), because a sixth hand-rolled resolution
 * chain is the drift `createNamespaceTranslate` was built to end.
 *
 * `{{double}}` braces with `keep` on a missing value — the template i18next itself interpolates, so
 * an unsupplied placeholder stays VISIBLE rather than silently blanking.
 *
 * @module @puffin-core/form-security/useFormSecurityTranslate
 */

import { createInterpolator } from '@puffin-core/i18n-bootstrap/strings-kit';
import { createNamespaceTranslate } from '@puffin-core/i18n-bootstrap/namespace-translate';

import { FORM_SECURITY_NAMESPACE } from './strings/namespace.js';
import { resolveString } from './strings/resolveString.js';

export const useFormSecurityTranslate = createNamespaceTranslate({
  namespace: FORM_SECURITY_NAMESPACE,
  resolveString,
  interpolate: createInterpolator({ braces: 'double', onMissing: 'keep' }),
});

export default useFormSecurityTranslate;
